import { useEffect, useRef } from "react";

import { IRegistrationGDPR } from "../../connection/registration";
import Socket, { SocketMessage } from "../../connection/socket";
import SocketManager from "../../connection/socket-main-thread/socket-manager";
import { useTypedSelector } from "../../store/reducers/use-typed-selector";
import { LanguagesAbbr, MarkedAttendedRegistration } from "../../types/working-model";

interface UserRegistration {
	registration_id?: number;
	event: number;
	created?: string;
	email: string | null;
	values: { [key: number]: string };
	from_saml: boolean;
	uuid?: string;
	valid_sessions: string[] | null;
	bl_profile: number | null;
	channel: number;
	user_sessions: number[] | null;
	utm_params: any | null;
	referrer?: string;
	hidden?: boolean;
	valid_passcode_lists?: number[];
	registered_language?: LanguagesAbbr;
	gdpr?: IRegistrationGDPR;
	registration_bypass?: boolean;
	marked_attended_by_admin?: MarkedAttendedRegistration;
	deleted: boolean;
}

const useResetRegistrationSockets = () => {
	const socket = useRef<Socket | null>(null);

	const eventBundle = useTypedSelector(event => event.LiveEventReducer.eventBundle);
	const registrationId = useTypedSelector(event => event.LiveEventReducer.registrationId);
	const registrationIdRef = useRef(registrationId);
	registrationIdRef.current = registrationId;

	const socketKey = `event-reset-registrations-${eventBundle?.uuid}`;

	// only acquire a new connection to this socket when the uuid actually changes and does not contain undefined (which is only while the page is loading)
	useEffect(() => {
		if (socketKey.includes('undefined')) return;

		socket.current = SocketManager.get(socketKey);

		const handleResetRegistrations = async (message: SocketMessage) => {
			if (registrationIdRef.current) {
				try {
					if (message?.data?.registrationsToRevoke?.length) {
						const registrations: UserRegistration[] = message.data.registrationsToRevoke;
						for (const registration of registrations) {
							if (registrationIdRef.current === registration.uuid) {
								window.location.reload();
								return;
							}
						}
					}
				} catch (e) {
					console.error(e);
				}
			}
		};

		socket.current?.addListener('reset_registrations', handleResetRegistrations);

		return () => {
			socket.current?.removeListener('reset_registrations', handleResetRegistrations);
			SocketManager.leave(socketKey);
		};
	}, [socketKey]);
};

export default useResetRegistrationSockets;
